<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <!--<h1>StudentIndexView</h1>-->
        <heading-view :right-column="show_table_view"></heading-view>

        <student-add-view v-if="show_add_view"></student-add-view>
        <student-table-view v-if="show_table_view"></student-table-view>
        <student-documents-view v-if="show_documents_view"></student-documents-view>
        <!--<v-tooltip top>-->
            <!--<template v-slot:activator="{ on, attrs }">-->

                <!--<v-btn v-bind="attrs" v-on="on" fab bottom right dark fixed color="primary" v-if="show_table_view"-->
                       <!--@click="showAddForm()">-->
                    <!--<v-icon>mdi-plus</v-icon>-->
                <!--</v-btn>-->
            <!--</template>-->
            <!--<span>Dodaj novog učenik</span>-->
        <!--</v-tooltip>-->
    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    import StudentAddView from "../student/StudentAddView";
    import StudentTableView from '../student/StudentTableView'
    import HeadingView from '../heading/HeadingView'
    import StudentDocumentsView from "./StudentDocumentsView";

    export default {

        components: {
            StudentAddView,
            StudentTableView,
            HeadingView,
            StudentDocumentsView
        },

        created: function () {
            let table = 'ucenik';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'StudentAddView';
            this.show_table_view = this.$route.matched[0].name === 'StudentTableView';
            this.show_documents_view = this.$route.matched[0].name === 'StudentDocumentsView';

            serverBus.$on('show-student-add-form', (item) => {
                this.$navigate('/admin/' + table + '/add' + (item.id > 0 ? '/' + item.id : ''));
            });

            serverBus.$on('show-student-profile', (item) => {
                this.$navigate('/admin/' + table + '/pregled/' + item.id);
            });
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-student-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-add-form');
            serverBus.$off('show-student-profile');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false,
                show_documents_view: false
            };
        }
    }
</script>